import { TableHeadersType } from "../tableHeadersType";

export const RECURRING_JOBS_REPORT_TABLE_HEADER:TableHeadersType[]=[
   
    {
        "label": "Job Type",
        "value": "job_type_name",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Description",
        "value": "description",
        "defaultChecked": true,
        "checked": true
    },
   
    {
        "label": "Manager",
        "value": "manager",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Currently Resposible",
        "value": "responsible",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label":"Cuttoff Date",
        "value":"engagement_cutoff_date",
        "defaultChecked":true,
        "checked":true
    },
    // {
    //     "label":"Count of maped job",
    //     "value":"updated_by",
    //     "defaultChecked":true,
    //     "checked":true
    // },
]

export const RECURRING_JOB_REPORT_CLIENT_HEADER=[
    {
        label: "Client Name",
        value: "client_name",
      },
]